import React, { Component } from "react";
import Button from "../button/Button";
import Modale from "../modale/Modale";
import { withTranslation } from "react-i18next";
import Ruoli from "../../utils/Ruoli";
import SessioneUtente from "../../sessionManager/SessioneUtente";

class ButtonRow extends Component {
    render() {
        //console.log("archiviato " + this.props.isArchiviato);

        const { t } = this.props;
        const buttonDiv = (
            <div
                className={
                    this.props.isArchiviato && !this.props.nextStep ? "" : "row"
                }
            >
                <div
                    className={
                        this.props.noSalva ||
                        (this.props.isArchiviato && this.props.nextStep)
                            ? "col-lg-6"
                            : this.props.isArchiviato && !this.props.nextStep
                            ? ""
                            : "col-lg-4"
                    }
                >
                    {this.props.isArchiviato ? (
                        <div style={{ textAlign: "center" }}>
                            <Button
                                id={"annulla"}
                                className="btnWhite"
                                text={t("Buttons.exit_solo")}
                                style={{ height: "3rem", marginTop: "1rem" }}
                                onClick={this.props.back}
                            />
                        </div>
                    ) : (
                        <Modale
                            classes="btnWhite"
                            id={"annulla"}
                            typeModal="modalConsenso"
                            modalText={t("Messages.ERR_01_01_0D_0A")}
                            text={
                                this.props.isArchiviato
                                    ? t("Buttons.exit_solo")
                                    : t("Buttons.esciSenzaSalvare")
                            }
                            title={t("Buttons.esciSenzaSalvare")}
                            textButtonOk={"Prosegui"}
                            textButtonKo={"Annulla"}
                            style={{ height: "3rem", marginTop: "1rem" }}
                            confirmFun={this.props.back}
                        />
                    )}
                </div>

                {this.props.noSalva || this.props.isArchiviato ? (
                    <div></div>
                ) : (
                    <div className="col-lg-4" style={{ textAlign: "center" }}>
                        <Button
                            text={t("Buttons.salva")}
                            disabled={this.props.disabledSalva}
                            onClick={this.props.onClickSalva}
                            className={"btnWhite"}
                            style={{ height: "3rem", marginTop: "1rem" }}
                        ></Button>
                    </div>
                )}
                <div
                    className={
                        this.props.noSalva || this.props.isArchiviato
                            ? "col-lg-6"
                            : "col-lg-4"
                    }
                >
                    {this.props.isArchiviato && this.props.nextStep ? (
                        <div style={{ textAlign: "center" }}>
                            <Button
                                id={"conferma"}
                                className="btnWhite"
                                text={t("Buttons.prosegui")}
                                style={{ height: "3rem", marginTop: "1rem" }}
                                onClick={this.props.onClickConfermaEProsegui}
                            />
                        </div>
                    ) : !this.props.isArchiviato ?
                        this.props.segnalazioneC2 ? (
                            <Modale
                                segnalazioneCopiaMod={this.props.segnalazioneC2}
                                classes="btnBlu"
                                id={"conferma"}
                                name={"conferma"}
                                typeModal="modalConsenso"
                                modalText={t("Messages.CONFERMA_MIB_FOCOLAI")}
                                text={t("Buttons.conferma")}
                                title={t("Salva e conferma")}
                                textButtonOk={"Conferma"}
                                textButtonKo={"Torna alla segnalazione"}
                                textButtonSalva={"Salva ed esci"}
                                onClickKo={this.props.onClickKo}
                                onClickOk={this.props.onClickConfermaEProsegui}
                                style={{ height: "3rem", marginTop: "1rem" }}
                                confirmFun={this.props.onClickFocolaio}
                                disabled={!this.props.isArchiviato && this.props.disabledConfermaProsegui}
                            />
                        ) : (
                            <Modale
                                classes="btnBlu"
                                id={"conferma"}
                                name={"conferma"}
                                typeModal="modalConsenso"
                                modalText={t(this.props.modalTextConferma)}
                                text={t("Buttons.conferma")}
                                title={t("Buttons.conferma")}
                                textButtonOk={"Prosegui"}
                                textButtonKo={"Annulla"}
                                onClickKo={this.props.onClickKo}
                                style={{ height: "3rem", marginTop: "1rem" }}
                                confirmFun={this.props.onClickConfermaEProsegui}
                                disabled={
                                    !this.props.isArchiviato &&
                                    this.props.disabledConfermaProsegui
                                }
                            />
                        ) : ""
                    }
                </div>
            </div>
        );

        const buttonCaricaAllegati =
            SessioneUtente.getInstance().ruoliUtente ===
                Ruoli.Operatore_Sisp.descrizione ||
            SessioneUtente.getInstance().ruoliUtente ===
                Ruoli.Operatore_Sisp_HIV.descrizione ||
            SessioneUtente.getInstance().ruoliUtente ===
                Ruoli.Operatore_Regionale.descrizione ? (
                <div
                    style={{
                        display:
                            this.props.allegati && !this.props.migrazione
                                ? ""
                                : "none",
                        textAlign: "center",
                        opacity: this.props.disabledCaricaAllegati
                            ? "0.5"
                            : "1",
                    }}
                >
                    <label
                        className="btnWhite"
                        style={{ height: "3rem", marginTop: "40px" }}
                    >
                        <input
                            type="file"
                            onChange={this.props.onClickAllegati}
                            style={{ display: "none" }}
                            accept="application/pdf"
                            multiple={true}
                            disabled={this.props.disabledCaricaAllegati}
                        />
                        <p style={{ height: "3rem", marginTop: "1rem" }}>
                            {t("Buttons.carica_allegati")}
                        </p>
                    </label>
                </div>
            ) : null;

        const buttonValidazione = (
            <div>
                {this.props.validazioneMalattia ? (
                    <Modale
                        classes="btnWhite"
                        id={"validazione"}
                        typeModal="modalConsenso"
                        modalText={t(
                            "Una volta validata la segnalazione non sarà più possibile modificare i dati inseriti.<br /><br />Si vuole procedere con la validazione della scheda?"
                        )}
                        text={"Validazione"}
                        title={"Validazione"}
                        style={{ height: "3rem", marginTop: "40px" }}
                        confirmFun={this.props.onClickValidazione}
                        disabled={
                            !this.props.confermaScheda ||
                            this.props.differenzaGiorniValidazione
                        }
                    />
                ) : (
                    <></>
                )}
            </div>
        );

        return (
            <div>
                {buttonCaricaAllegati}
                {buttonDiv}
                {buttonValidazione}
            </div>
        );
    }
}

export default withTranslation("common")(ButtonRow);
